module.exports = __webpack_public_path__ + "static/media/defaultCover.cb3e1b8f.jpg";